import { useEffect } from 'react';
import CollaboXDLogo from './CollaboXDLogo';
import Icon from './Icon';
import { COLORS, FONTS, TRACKING } from '../styles/tokens';
import { contentWrap, primaryButton, cardBase, kicker } from '../styles/shared';

const VALUE_PROPS = [
  {
    icon: 'analytics',
    title: 'Personalized Report',
    body: 'Content tailored to your org type, your scored level in each dimension, and your recommended service path.',
  },
  {
    icon: 'my_location',
    title: 'A Clear Next Step',
    body: 'No fluff. A practical recommendation and three concrete things you can do this week, built around where you actually are.',
  },
];

export default function IntroScreen({ onStart }) {
  useEffect(() => {
    function onKey(e) {
      if (e.key === 'Enter') { e.preventDefault(); onStart(); }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onStart]);

  return (
    <div style={{ minHeight: '100vh', background: COLORS.bgApp, padding: '0 20px', boxSizing: 'border-box' }}>
      <main id="main-content" style={{ ...contentWrap, maxWidth: 880, textAlign: 'center' }}>

        {/* Nav */}
        <div style={{ padding: '40px 0 0', display: 'flex', justifyContent: 'center' }}>
          <CollaboXDLogo height={56} />
        </div>

        {/* Hero */}
        <div style={{ padding: '64px 0 52px' }}>
          <p style={{ ...kicker, marginBottom: 20 }}>AI Readiness Assessment</p>
          <h1 style={{
            fontFamily: FONTS.heading,
            fontWeight: 700,
            letterSpacing: TRACKING.tightHeadline,
            fontSize: 'clamp(32px, 5vw, 54px)',
            lineHeight: 1.15,
            color: COLORS.textPrimary,
            margin: '0 auto 24px',
            maxWidth: 720,
          }}>
            Find out where your organization stands on AI.
          </h1>
          <p style={{
            fontFamily: FONTS.body,
            fontSize: 18,
            lineHeight: 1.65,
            color: COLORS.textSecondary,
            margin: '0 auto 40px',
            maxWidth: 520,
          }}>
            Under 6 minutes. A personalized readiness report built around your organization — not a generic checklist.
          </p>

          <button
            style={{ ...primaryButton, fontSize: 15, padding: '18px 52px' }}
            onClick={onStart}
            onMouseEnter={e => {
              e.currentTarget.style.background = '#0098D2';
              e.currentTarget.style.transform = 'translateY(-1px)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,173,239,0.4)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = COLORS.accent;
              e.currentTarget.style.transform = '';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(37,47,106,0.25)';
            }}
          >
            Start the Assessment
          </button>

          <p style={{
            fontFamily: FONTS.body,
            fontSize: 14,
            color: COLORS.textMuted,
            margin: '16px 0 0',
          }}>
            <em>We don't share your information. Ever.</em>
          </p>
        </div>

        {/* Value props */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          gap: 16,
          paddingBottom: 80,
          textAlign: 'left',
        }}>
          {VALUE_PROPS.map(vp => (
            <div key={vp.title} style={{
              ...cardBase,
              borderRadius: 8,
            }}>
              <div style={{ marginBottom: 14 }}>
                <Icon name={vp.icon} size={26} style={{ color: COLORS.holidayBlue }} />
              </div>
              <h3 style={{
                fontFamily: FONTS.heading,
                fontSize: 18,
                fontWeight: 700,
                color: COLORS.textPrimary,
                margin: '0 0 8px',
              }}>{vp.title}</h3>
              <p style={{
                fontFamily: FONTS.body,
                fontSize: 15,
                lineHeight: 1.6,
                color: COLORS.textSecondary,
                margin: 0,
              }}>{vp.body}</p>
            </div>
          ))}
        </div>

      </main>
    </div>
  );
}
